/** Month options for the fiscal-year start pickers, shared by the location create form and the
 *  location General tab so the two cannot drift. Values are 1-based, as the location events store them. */
export const months: { label: string; value: number }[] = [
  { label: 'app.january', value: 1 },
  { label: 'app.february', value: 2 },
  { label: 'app.march', value: 3 },
  { label: 'app.april', value: 4 },
  { label: 'app.may', value: 5 },
  { label: 'app.june', value: 6 },
  { label: 'app.july', value: 7 },
  { label: 'app.august', value: 8 },
  { label: 'app.september', value: 9 },
  { label: 'app.october', value: 10 },
  { label: 'app.november', value: 11 },
  { label: 'app.december', value: 12 },
]
